import { getWindow } from "@faire/web/common/globals/getWindow";

export type PerformanceMarkStartTime = Pick<PerformanceMark, "startTime">;

export function markPageJsExecuted(): PerformanceMarkStartTime | undefined {
  const performance = getWindow()?.performance;
  /**
   * performance.mark may be undefined in:
   *  - tests (js-dom)
   *  - server-side (next.js)
   *  - in old browsers
   **/
  if (performance?.mark) {
    return performance.mark("page-js-executed");
  } else if (performance?.now) {
    return { startTime: performance.now() };
  } else {
    return undefined;
  }
}
